import RGPD from '../utils/RGPD'

export default
{
    data()
    {
        return { }
    },

    created()
    {

    },

    mounted()
    {
        
    },

    destroyed()
    {

    },

    methods:
    {
        accept()
        {
            this.$emit('accept')
        },
        
        decline()
        {
            this.$emit('decline')
        }
    }
}